const { mapValues, groupBy, sumBy, isEmpty, } = require('lodash');
const { format: formatDate, } = require('date-fns');

const locales = {
  ja: { label: '日本語', },
  en: { label: '英語', },
};

const currencies = {
  yen: { label: '日本円', },
  usd: { label: 'USドル', },
};

const { entries } = Object;

const poDateFieldOptions = [
  { value: 'piReceivedOn', label: 'PI受信日' },
  { value: 'advancePaymentOn', label: '前金支払日' },
  { value: 'colorSpecificationDate', label: '色指定日' },
  { value: 'tireArrivalDate', label: 'タイヤ入荷日' },
  { value: 'frameArrivalDate', label: 'フレーム入荷日' },
  { value: 'otherPartsArrivalDate', label: 'その他パーツ入荷日' },
  { value: 'onlineInspectionDate', label: 'オンライン検品日' },
  { value: 'onlineInspectionResult', label: 'オンライン検品結果' },
  { value: 'balancePaymentOn', label: '残金支払日' },
  { value: 'requestEtd', label: '工場出荷希望日' },
];

module.exports = {
  fields: () => {
    return {
      name: {
        label: '名称',
        type: 'string',
        validations: {
          required: v => !isEmpty(v),
        },
      },
      locale: {
        label: '言語',
        type: 'select',
        options: entries(locales).map(([k, v]) => ({ label: v.label, value: k })),
        validations: {
          required: v => !isEmpty(v),
        },
      },
      currency: {
        label: '通貨',
        type: 'select',
        options: entries(currencies).map(([k, v]) => ({ label: v.label, value: k })),
        validations: {
          required: v => !isEmpty(v),
        },
      },
      emailTo: {
        label: 'メールTO',
        type: 'string',
        hint: 'カンマ区切りで複数指定できます',
      },
      customizesPoDateFields: {
        label: 'PO日付項目の表示を設定する',
        type: 'boolean',
      },
      visiblePoDateFields: {
        label: '表示PO日付項目',
        type: 'multiSelect',
        options: poDateFieldOptions,
        hidden: _ => !_.customizesPoDateFields,
      },
    };
  },
  locales,
  currencies,
};
